// packages/web/src/hooks/useAdminAuth.ts
import { useState, useEffect } from 'react';
import { api } from '../services/api'; // Adjust this import path if needed

// This hook checks if the current user is an admin
export const useAdminAuth = (user: any | null) => {
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const checkAdminStatus = async () => {
      setIsLoading(true);
      
      try {
        // First check if user exists
        if (!user) {
          console.log('No user found, not an admin');
          setIsAdmin(false);
          return;
        }
        
        console.log('Checking admin status for user:', user.email);
        
        // Option 1: If your user object already has an admin flag or role
        if (user.role === 'admin' || user.isAdmin) {
          console.log('User has admin role/flag in user object');
          setIsAdmin(true);
          return;
        }
        
        // Option 2: Check with the server if this user is an admin
        try {
          // Make an API call to check admin status
          const response = await fetch('/api/user/check-admin-status', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include', // Important for sending cookies
          });
          
          if (response.ok) {
            const data = await response.json();
            console.log('Admin status response:', data);
            if (data.isAdmin) {
              console.log('User is admin based on server verification');
              setIsAdmin(true);
              return;
            }
          }
        } catch (apiError) {
          console.error('Error checking admin status with API:', apiError);
        }
        
        // Option 3: Fallback to environment variable check
        // Only use environment variables, no hardcoded values
        const adminEmailsEnv = process.env.REACT_APP_ADMIN_EMAILS || '';
        const adminEmails = adminEmailsEnv.split(',').filter(email => email.trim() !== '');
          
        console.log('Admin emails (from env):', adminEmails);
        console.log('Current user email:', user.email);
        
        if (user.email && adminEmails.includes(user.email.trim())) {
          console.log('User is admin based on email match');
          setIsAdmin(true);
          return;
        }
        
        console.log('User is not an admin');
        setIsAdmin(false);
      } catch (error) {
        console.error('Error checking admin status:', error);
        setIsAdmin(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAdminStatus();
  }, [user]);

  return { isAdmin, isLoading };
};

export default useAdminAuth;